<template>
  <div>
    Frais Médicaux
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'FraisMedicaux'
}
</script>
